import { useEffect } from 'react'
import { Link } from 'react-router-dom';

const Page404 = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [])

    return (
        <div className="not-found-container-wrapper">
            <div className="not-found-content">

                <h3 className="not-found-title">Sorry, page not found!</h3>

                <p className="not-found-description">
                    Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL?
                    Be sure to check your spelling.
                </p>

                <div className="not-found-illustration">
                    <img src={`${process.env.PUBLIC_URL}/assets/img/illustration_404.svg`} alt="404 Illustration" class="illustration" />
                </div>

              <Link to='/' className='not-found-btn'>Go to Home</Link>

            </div>
        </div>
    );
};

export default Page404